// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/*jshint esversion: 6 */

import Vue from 'vue';
import App from './App';
import router from './router';
//import WeVue from 'we-vue';
import Vant, { Lazyload } from 'vant';
import 'vant/lib/index.css';
import wx from "weixin-jsapi";
import VWechatAuth from 'v-wechat-auth';
import axios from 'axios';
// import VueMobileDetection from 'vue-mobile-detection';

// Remove it before release
// import VConsole from 'vconsole/dist/vconsole.min.js';

// Remove it before release
// let vConsole = new VConsole();
Vue.config.productionTip = false;
Vue.prototype.serverIP = document.domain;
Vue.prototype.wx = wx;
//Vue.prototype.uauth = 0;

//Vue.use(WeVue);
Vue.use(Vant);
Vue.use(Lazyload, {
  lazyComponent: true
});
// Vue.use(VueMobileDetection);

Vue.use(VWechatAuth);

let config = {
  appId: 'wx57918790130c9f08',
  scope: 'snsapi_base', // snsapi_base or snsapi_userinfo
  /**
   * 
   * @param {*} code 
   * @param {*} success if you use callback, don't return anything in the function, and call success and pass response data to it
   * @param {*} fail 
   */
  authorize (code, success, fail) {
    return axios.get('/api/authorize', { params: { code: code } })
    .then(res => {
      var data = (res && res.data) || {}; // response data should at least contain openid
      console.log(JSON.stringify(data));
      return data;
    });
  }
};

const uauth = Vue.observable({
  auth: 0
});

Object.defineProperty(Vue.prototype, '$uauth', {
  get () {
    return uauth.auth;
  },
  
  set (value) {
    uauth.auth = value;
  }
});

sessionStorage.setItem('UAUTH', 0);

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    var UAUTH = sessionStorage.getItem('UAUTH');
    if (UAUTH != 1) {
      next({
        path: '/uauth',
        query: {
          to: to.path
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  data: {
    user: {}
  },
  wechatAuth: new VWechatAuth(config),
  created () {
    var vm = this;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|HarmonyOS/i.test(navigator.userAgent)) {
      this.$wechatAuth.authorize()
        .then((res) => {
          if (res.success == true) {
            //console.log("openid:", res.openid);
            sessionStorage.setItem('openid', res.openid);
            sessionStorage.setItem('UAUTH', 1);
            vm.user = res;
            vm.$uauth = 1;
          } else {
            sessionStorage.setItem('openid', res.openid);
            sessionStorage.setItem('UAUTH', -1);
            vm.$uauth = -1;
          }
        })
        .catch((error) => {
          sessionStorage.setItem('UAUTH', -1);
          vm.$uauth = -1;
        });
    }
  },
  template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js